import { IInfoToggleStyleProps, IInfoToggleStyles } from './InfoToggle.types';

export const getStyles = (props: IInfoToggleStyleProps): IInfoToggleStyles => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
    },
    subComponentStyles: {
      toggle: {
        root: {
          marginBottom: '0px',
        },
      },
    },
  };
};
